<template>
<div id="ccLogin">

  <div class="container">
  <div class="row">
  <div class="col-10 offset-1" style="border:10px solid #171a26; background:rgba(19,21,31,0.7); margin-top:50px; padding:50px 0 50px 0; border-radius: 15px;">

    <div class="row">
      <div class="col-md-6 offset-3">

          <p class="text-center mb-5">
              <img :src='"../../assets/image/logo_sokker.png"' alt="Responsive image" :title='"sokkerduel"' width="180px">
          </p>

          <div class="mb-4 text-center" style="color:#fff; text-align:justify; font-size: 20px;">
              {{ texto }}
          </div>

          <div class="row mt-5">
            <div class="col-md-12 text-center">

              <p class="text-center"><router-link to="/login" style="color: #fff;">Voltar</router-link></p>

            </div>
          </div>

      </div>
    </div>

  </div>
  </div>
  </div>

</div>
</template>

<script>

var basehost = process.env.BASE_HOST;
var base_url_api = process.env.BASE_URL_API;
import axios from 'axios';

export default {

  data () {
    return {
      token: null,
      loging: false,
      texto: "",
    }
  },

  created(){
    this.token = this.$route.params.token
    this.validar_email()
  },

  methods: {

      async validar_email()
      {
        this.loading = true
        axios.get(base_url_api+'email/validar/'+this.token)
        .then(response => {

          if (response.status === 200) {
              if (response.data.status === 'success') {
                  this.texto = "Email confirmado."
              }
          }else{
              if (response.data.status === 'token_usado') {
                  this.texto = "Email confirmado."
              }
              if (response.data.status === 'user_not_found') {
                  this.texto = "Cadastro não encontrado."
              }
          }

          this.loading = false
        })
        .catch(function(error){
              console.log(error)
              if (error.response && error.response.status === 203 && error.response.data) {
              let slugValue = error.response.data[0].slug;

              if(slugValue == 'user_not_found') { slugValue = 'CPF não encontrado!'}

                this.box_alert_text = slugValue
                this.box_cor = 0
                this.box_alert = true;
              } else {
                console.log(error.response.status);
              }

              this.loading = false;
        });
      }

  },

}
</script>


// WEBPACK FOOTER //
// src/components/login/email_validar.vue